import * as React from 'react';
import classnames from 'classnames';
import { RadioButton, Price } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { baseClassName } from '../styles/index.js';

const className = `${baseClassName}-item`;
const Solution = ({ isChecked , isLoading , onChange , solution , title  })=>{
    const { bundleSku , bundlePrice , description , imageUrl  } = solution;
    return /*#__PURE__*/ React.createElement("div", {
        className: `${className}__wrapper`
    }, /*#__PURE__*/ React.createElement(RadioButton, {
        isChecked: isChecked,
        onChange: onChange,
        position: "bottom",
        value: bundleSku,
        disabled: isLoading,
        className: classnames(className, {
            [`${className}--empty`]: !description && !imageUrl
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: `${className}__container`
    }, imageUrl && /*#__PURE__*/ React.createElement("div", {
        className: `${className}__image-holder`
    }, /*#__PURE__*/ React.createElement("img", {
        className: `${className}__image`,
        src: imageUrl,
        alt: title
    })), /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        className: `${className}__title`
    }, title), bundlePrice[0] && bundlePrice[0].value && /*#__PURE__*/ React.createElement("span", {
        className: `${className}__price`
    }, /*#__PURE__*/ React.createElement(Price, {
        value: bundlePrice[0].value.centAmount,
        currency: bundlePrice[0].value.currencyCode
    })))));
};

export { Solution };
//# sourceMappingURL=Solution.js.map
